import styles from './HistorySheet.module.css';

export function HistoryClock({ label, onClick, disabled, testId }: { label: string; onClick: () => void; disabled?: boolean; testId?: string }): JSX.Element {
  return <button type="button" className={styles.clock} aria-label={label} onClick={onClick} disabled={disabled} data-testid={testId}>
    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
  </button>;
}
